import { Analysis, AnalysisStatus } from '../models/general/analysis';
import { orchestrator } from '../websocket/orchestrator';

const ACTIVE_STATUSES = [AnalysisStatus.WAITING, AnalysisStatus.PROCESSING];

export function registerActiveAnalysisConnections(analyses: Analysis[]): void {
  for (const analysis of analyses) {
    if (analysis.id && analysis.status && ACTIVE_STATUSES.includes(analysis.status)) {
      orchestrator.addConnection({
        route: 'analysis',
        id: analysis.id,
        storageKey: `analysis_${analysis.id}`,
      });
    }
  }
}
